import { ApprovalRequestCategory } from '@/api/types/approvalRequests';
import { ApprovalRequestsTabsPage } from './ApprovalRequestsTabsPage';

export function ProvidersRequestsPage({ initialTab }: { initialTab: 'requests' | 'history' }) {
  return (
    <ApprovalRequestsTabsPage
      category={ApprovalRequestCategory.Aml}
      title="Providers Requests"
      scope="providers"
      basePath="/User/DailyReconciliation/ProvidersRequests"
      viewRequestsPermission="User.SafeguardingReconciliation.ProvidersRequests.Requests"
      viewHistoryPermission="User.SafeguardingReconciliation.ProvidersRequests.History"
      approveRejectPermission="User.SafeguardingReconciliation.ProvidersRequests.ApproveReject"
      initialTab={initialTab}
    />
  );
}
